import React from "react";
import Menu from "../Menu";

import styles from "./Item.module.scss";

const HeaderLink = props => <Menu.Item className={styles.base} {...props} />;

export default HeaderLink;
